import { useId } from "react";

export const ReviewStar = ({
  filled = false,
  fillPercentage,
  className,
}: {
  filled?: boolean;
  fillPercentage?: number;
  className?: string;
}) => {
  const percentage = fillPercentage ?? (filled ? 100 : 0);
  const gradientId = `star-gradient-${useId()}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className={className ?? "h-5 w-5"}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradientId}>
          <stop offset={`${percentage}%`} stopColor="currentColor" />
          <stop offset={`${percentage}%`} stopColor="#D1D5DB" />
        </linearGradient>
      </defs>
      <path
        d="M10 1.5l2.5 5 5.5.75-4 3.75 1 5.5-5-2.5-5 2.5 1-5.5-4-3.75 5.5-.75 2.5-5z"
        fill={`url(#${gradientId})`}
        stroke="currentColor"
        strokeWidth="0.5"
        strokeOpacity="0.2"
      />
    </svg>
  );
};
